// Trial post-expiry grace window, in whole days. After a trial's `ended_at`,
// the workspace stays usable for this window; once it is exceeded the
// workspace is restricted (jobs paused). This is the SINGLE source of truth
// shared by the SubscriptionProvider restriction logic and the
// TrialUsageBanner countdown so the "N days left" copy can never disagree with
// when actions actually block (#2689).
//
// Set to 0 = NO grace window: the workspace is restricted the moment the trial
// expires (the same day `ended_at` passes), and the banner shows the plain
// "trial has expired" copy instead of a "N days left" countdown.
export const TRIAL_GRACE_DAYS = 0;

// Whether the post-expiry grace window has been fully consumed, given how many
// whole days have passed since the trial's `ended_at`. With TRIAL_GRACE_DAYS=0
// this is true from the expiry day itself (daysSinceEnd >= 0), i.e. no grace.
// Drives `isWorkspaceRestricted`.
export const isTrialGraceExpired = (daysSinceTrialEnd: number): boolean =>
    daysSinceTrialEnd >= TRIAL_GRACE_DAYS;

// Whole days of grace remaining before the workspace is restricted. With
// TRIAL_GRACE_DAYS=0 this is always 0 on/after the expiry day, so the banner's
// countdown branch never renders — it goes straight to the "trial has expired"
// copy — which agrees with `isTrialGraceExpired` by construction.
export const trialGraceDaysRemaining = (daysSinceTrialEnd: number): number =>
    Math.max(0, TRIAL_GRACE_DAYS - daysSinceTrialEnd);

export const mapping_subscription_package: { [key: string]: { subscription_plan_wording: string, is_subscription_quarterly?: boolean } } = {
    "49185f71-a448-4cf3-a535-857fcec3b6b7": {
        "subscription_plan_wording": "Quarterly",
        "is_subscription_quarterly": true,
    },
    "88644525-dfec-4c87-b008-02df5ebf9e55": {
        "subscription_plan_wording": "Quarterly",
        "is_subscription_quarterly": true,
    },
    "f7a37e01-7049-40a8-9636-4d297d7956f1": {
        "subscription_plan_wording": "Annually",
        "is_subscription_quarterly": false,
    }
}